<div class="parent">
  <div>
    <div>
      <app-celo-pick-participants
        [title]="''"
        [participants]="participants"
        [selectedParticipantIds]="selectedParticipantIds"
        [hideProfession]="false"
        [hideSelectionInfo]="true"
        (pick)="onUpdate($event)"
        (preview)="openPreview($event)"
        [showBadge]="true"
      ></app-celo-pick-participants>
    </div>
    <div class="buttons">
      @if (selectedParticipantIds?.length && !saving) {
        <div class="p-2">
          <div class="button">
            <button
              class="celo-primary-button next"
              (click)="editConversationSave()"
              [disabled]="loading || !selectedParticipantIds?.length"
            >
              <span
                >REMOVE
                @if (selectedParticipantIds?.length) {
                  <span>({{ selectedParticipantIds.length }})</span>
                }
              </span>
            </button>
          </div>
          <div class="button">
            <button
              class="celo-button-orange-outline cancel"
              [disabled]="loading"
              (click)="cancel()"
            >
              Cancel
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</div>
